import React, { useMemo } from 'react';
import { computeAgeYears, computeBmiDisplay } from '../../utils/wizardFormFromUser';

export default function WizardStepPhysical({ formData, onChange }) {
  const patch = (partial) => onChange({ ...formData, ...partial });

  const bmiDisplay = useMemo(
    () => computeBmiDisplay(formData.heightCm, formData.weightKg),
    [formData.heightCm, formData.weightKg]
  );
  const ageYears = useMemo(() => computeAgeYears(formData.birthDate), [formData.birthDate]);

  return (
    <div className="space-y-5">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-wider text-iron-accent">Características físicas</p>
        <p className="mt-1 text-xs text-iron-muted">
          Altura e peso entram no fingerprint da IA. IMC calculado no cliente.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div>
          <label className="section-label mb-2 block">Altura (cm)</label>
          <input
            type="number"
            min="100"
            max="250"
            value={formData.heightCm}
            onChange={(e) => patch({ heightCm: e.target.value })}
            className="input"
            placeholder="175"
          />
        </div>
        <div>
          <label className="section-label mb-2 block">Peso (kg)</label>
          <input
            type="number"
            min="30"
            max="300"
            step="0.1"
            value={formData.weightKg}
            onChange={(e) => patch({ weightKg: e.target.value })}
            className="input"
            placeholder="75"
          />
        </div>
        <div>
          <label className="section-label mb-2 block">
            Data nascimento{' '}
            <span className="font-normal normal-case text-iron-muted">(opcional)</span>
          </label>
          <input
            type="date"
            value={formData.birthDate}
            onChange={(e) => patch({ birthDate: e.target.value })}
            className="input"
          />
        </div>
      </div>

      {(bmiDisplay != null || ageYears != null) && (
        <div className="rounded-xl border border-iron-border bg-iron-surface px-4 py-3 font-mono text-xs text-iron-muted">
          {bmiDisplay != null && (
            <span className="mr-4">
              IMC: <strong className="text-iron-accent">{bmiDisplay}</strong>
            </span>
          )}
          {ageYears != null && (
            <span>
              Idade: <strong className="text-iron-text">{ageYears}</strong> anos
            </span>
          )}
        </div>
      )}
    </div>
  );
}
